module.exports = __webpack_public_path__ + "img/seed-analyzer-logo.f1157ebc.png";